var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKeyboards(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "keys",
    width: 86,
    height: 94,
    viewBox: "0 0 86 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.1 3H81.2C82.3 3 83.2 3.9 83.2 5V60.8C83.2 62.1 82.6 63.3 81.6 64L45.5 90.6C44.1 91.6 42.2 91.6 40.7 90.6L4.6 64C3.6 63.2 3 62 3 60.8V5C3 3.9 3.9 3 5 3H43.1Z",
    stroke: "#D89F5B",
    strokeWidth: 4.0121,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1 28.2H11.8C11.1 28.2 10.5 27.6001 10.5 26.9001V4.30005H18.5V26.8C18.5 27.6 17.9 28.2 17.1 28.2Z",
    fill: "#D89F5B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3999 28.2V51.9",
    stroke: "#D89F5B",
    strokeWidth: 2.0061,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4999 28.2H23.1999C22.4999 28.2 21.8999 27.6001 21.8999 26.9001V4.30005H29.8999V26.8C29.7999 27.6 29.1999 28.2 28.4999 28.2Z",
    fill: "#D89F5B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8 28.2V51.9",
    stroke: "#D89F5B",
    strokeWidth: 2.0061,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3 4.30005V51.9001",
    stroke: "#D89F5B",
    strokeWidth: 2.0061,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M83.2 51.8999H3",
    stroke: "#D89F5B",
    strokeWidth: 2.0061,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3 28.2H46C45.3 28.2 44.7 27.6001 44.7 26.9001V4.30005H52.7V26.8C52.6 27.6 52 28.2 51.3 28.2Z",
    fill: "#D89F5B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6001 28.2V51.9",
    stroke: "#D89F5B",
    strokeWidth: 2.0061,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8 28.2H57.5C56.8 28.2 56.2 27.6001 56.2 26.9001V4.30005H64.2V26.8C64.1 27.6 63.5 28.2 62.8 28.2Z",
    fill: "#D89F5B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1001 28.2V51.9",
    stroke: "#D89F5B",
    strokeWidth: 2.0061,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M74.3999 28.2H69C68.3 28.2 67.7 27.6001 67.7 26.9001V4.30005H75.7V26.8C75.7 27.6 75.0999 28.2 74.3999 28.2Z",
    fill: "#D89F5B"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M71.7 28.2V51.9",
    stroke: "#D89F5B",
    strokeWidth: 2.0061,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyboards);
export default __webpack_public_path__ + "static/media/keyboards.2610534a9814137e13d858a6a94f9a46.svg";
export { ForwardRef as ReactComponent };